import { useTravelModuleStatus } from '../features/travel/common/useTravelModuleStatus.js';
import { useMeritPayrollModuleStatus } from '../features/payroll/merit/useMeritPayrollModuleStatus.js';
import { useGroupLearningAccess } from '../features/group-learning/useGroupLearning.js';
import type { NavSwitchFlags } from './nav.js';

/**
 * Which admin-switchable features (see `NavSwitch`) are ON for the signed-in user's organisation, in the shape `visibleNav`
 * takes as its fourth argument. A hook, because the answer comes from the API; `nav.ts` itself stays
 * pure data. Fails closed: while the answer is loading, or if it fails, a module's entries are
 * hidden, so a menu never advertises a page that would only say "not enabled".
 */
export function useNavSwitches(): NavSwitchFlags {
  const travel = useTravelModuleStatus();
  const meritPayrollApply = useMeritPayrollModuleStatus();
  const groupLearning = useGroupLearningAccess();
  return {
    travel: travel.enabled,
    merit_payroll_apply: meritPayrollApply.enabled,
    group_member: groupLearning.isMember,
  };
}
